const unsupportedCSSList = [
  ['inset-inline-start', '20px'],
  ['margin-block-start', '20px'],
];

export const containsUnsupportedCSS = () => {
  for (const cssString of unsupportedCSSList) {
    if (!CSS?.supports || CSS.supports(cssString[0], cssString[1]) === false)
      return true;
  }
  return false;
};
